export default __webpack_public_path__ + "static/media/LCCP.e21674a2.png";